import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import EquipmentFormComponent from "./_form"

interface EquipmentForm {
  name: string
  equipment_type_id: number | null
  year: number | null
  manufacturer: string
  model: string
  serial_number: string
  purchased_at: string | null
  purchased_from_vendor_id: number | null
  purchase_price: number | null
  serviced_by_vendor_id: number | null
  notes: string
  hourly_rate: number | null
  daily_rate: number | null
  requires_odometer: boolean
  sort_name: string
}

interface Option {
  id: number
  name: string
}

interface Props {
  equipment: EquipmentForm
  equipment_types: Option[]
  vendors: Option[]
  errors?: Record<string, string[]>
}

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Equipment", href: "/equipment" },
  { title: "New Equipment", href: "/equipment/new" },
]

export default function New({
  equipment,
  equipment_types,
  vendors,
  errors,
}: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Equipment" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">New Equipment</h1>

        <EquipmentFormComponent
          equipment={equipment}
          equipment_types={equipment_types}
          vendors={vendors}
          errors={errors}
          submitUrl="/equipment"
          submitMethod="post"
        />
      </div>
    </AppLayout>
  )
}
